import { Link } from "react-router-dom";

const links = [
  { label: "Home", href: "/" },
  { label: "Rates", href: "/rates" },
  { label: "Industries", href: "/industries" },
  { label: "Markets", href: "/markets" },
  { label: "Get a Quote", href: "/quote" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-border py-12">
      <div className="container text-center">
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-4">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-sm font-body text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <p className="text-xs text-muted-foreground font-body">
          © {new Date().getFullYear()} PowerRate. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
